import qs from "qs";
import CryptoJS from "crypto-js";
import urlencode from "urlencode";
import { Loading, Message } from "element-ui";
import OSS from "ali-oss";

/**
 * OSS 上传：STS AssumeRole → put 直传 → 拼接公网地址
 * 配置值保留 exam 环境原账号（与 ubt-education 无关）
 */
const OSS_CONFIG = {
  endpoint: "https://oss-cn-beijing.aliyuncs.com",
  region: "oss-cn-beijing",
  accessKeyId: "LTAI5tDmXAHfWfijAwzYAga7",
  accessKeySecret: "k9HRlP8M3rcU09wSlJOYIPwwBFQurM",
  bucket: "airoteachnew",
  roleArn: "acs:ram::1024137040541588:role/teachoss",
  roleSessionName: "teachoss"
};

function pad2(n) {
  return String(n).padStart(2, "0");
}

function createUuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/** 对象路径：{fileType}/yyyy/MM/dd/HHmmss/{uuid}{ext} */
function buildObjectKey(fileType, fileName) {
  const now = new Date();
  const timestamp = [
    now.getFullYear(),
    pad2(now.getMonth() + 1),
    pad2(now.getDate()),
    `${pad2(now.getHours())}${pad2(now.getMinutes())}${pad2(now.getSeconds())}`
  ].join("/");
  const name = String(fileName || "");
  const dot = name.lastIndexOf(".");
  const ext = dot >= 0 ? name.substring(dot).toLowerCase() : ".bin";
  const prefix = (fileType && String(fileType).trim()) || "image";
  return `${prefix}/${timestamp}/${createUuid()}${ext}`;
}

function buildPublicUrl(objectKey) {
  return (
    OSS_CONFIG.endpoint.replace("https://", `https://${OSS_CONFIG.bucket}.`) +
    "/" +
    objectKey
  );
}

async function assumeRole() {
  const params = {
    AccessKeyId: OSS_CONFIG.accessKeyId,
    Action: "AssumeRole",
    Format: "JSON",
    RoleArn: OSS_CONFIG.roleArn,
    RoleSessionName: OSS_CONFIG.roleSessionName,
    SignatureMethod: "HMAC-SHA1",
    SignatureNonce: String(Date.now()),
    SignatureVersion: "1.0",
    Timestamp: new Date().toISOString().replace(/\..+/, "") + "Z",
    Version: "2015-04-01"
  };
  const CanonicalizedQueryString = qs.stringify(params);
  const StringToSign =
    "GET" + "&" + urlencode("/") + "&" + urlencode(CanonicalizedQueryString);
  const Signature = CryptoJS.enc.Base64.stringify(
    CryptoJS.HmacSHA1(StringToSign, `${OSS_CONFIG.accessKeySecret}&`)
  );
  const url =
    "https://sts.aliyuncs.com/?" + qs.stringify({ ...params, Signature });

  console.log("[1/3] STS AssumeRole...");
  // 用 fetch，避免项目 axios.defaults.baseURL 干扰
  const response = await fetch(url, { method: "GET" });
  const data = await response.json();
  if (!data || !data.Credentials) {
    throw new Error("STS 未返回 Credentials: " + JSON.stringify(data));
  }
  console.log("  AccessKeyId:", data.Credentials.AccessKeyId);
  console.log("  Expiration:", data.Credentials.Expiration);
  return data.Credentials;
}

/**
 * @param {string} fileType 目录前缀，默认 image
 * @param {File|Blob} file
 * @param {string} fileName
 */
export const uploadFile = async (fileType, file, fileName) => {
  if (!file) {
    Message.error("没有可上传的文件");
    throw new Error("file is empty");
  }

  let loadingInstance;
  try {
    loadingInstance = Loading.service({
      lock: true,
      text: "上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });

    const credentials = await assumeRole();

    const client = new OSS({
      accessKeyId: credentials.AccessKeyId,
      accessKeySecret: credentials.AccessKeySecret,
      stsToken: credentials.SecurityToken,
      bucket: OSS_CONFIG.bucket,
      region: OSS_CONFIG.region,
      secure: true
    });

    const objectKey = buildObjectKey(
      fileType || "image",
      fileName || file.name || "file.bin"
    );
    const publicUrl = buildPublicUrl(objectKey);

    console.log("[2/3] put", objectKey);
    const result = await client.put(objectKey, file);
    console.log("  status:", result.res && result.res.status);
    console.log("[3/3] 公网地址:", publicUrl);

    result.name = objectKey;
    result.url = publicUrl;
    if (!result.res) result.res = {};
    result.res.status = (result.res && result.res.status) || 200;
    result.res.requestUrls = [publicUrl];
    return result;
  } catch (e) {
    console.error("[OSS] upload fail", e);
    Message.error((e && (e.message || e.code)) || "上传失败");
    throw e;
  } finally {
    if (loadingInstance) loadingInstance.close();
  }
};



// WEBPACK FOOTER //
// ./src/utils/alioss.js